/// <reference path="../../../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class ApiGridConfigurationModel {
        public currentApiGrid: Wars.Domain.Model.ApiGridConfiguration;
        public apiActions: Wars.Domain.Model.ApiAction[];
        public filteredApiActions: Wars.Domain.Model.ApiAction[];
        public apiGridConfigurations: Wars.Domain.Model.ApiGridConfiguration[];
        public processTypes: Wars.Domain.Model.ProcessType[];
        public selectedApiAction: Wars.Domain.Model.ApiAction;
        public objectQueries:Wars.Domain.Model.ObjectQuery[];

        constructor(private processConfigurationId: string, private apiGridConfigurationService: services.ApiGridConfigurationService,
            private apiConfigurationService: services.ApiActionService,
            private deleteService: services.DeleteService, private systemLevelService:services.SystemLevelService) {

            this.apiConfigurationService.getApiConfigurations().then(r => {
                this.apiActions = r;

                this.processTypes = Enumerable.from(this.apiActions).select(a => a.processConfiguration.myProcessType).distinct().toArray();
                //console.log(this.processTypes);
            });

            this.systemLevelService.getSystemLevelObjectQueries().then(r => {
                this.objectQueries = r.myObjectQueries;
            });

            this.systemLevelService.getSystemLevelSystemActions().then(r => {
                this.systemActions= r.mySystemActions;
            });

            apiGridConfigurationService.getApiGridConfigurations(processConfigurationId).then(result => {
                this.apiGridConfigurations = result;
            });
        }

        public save() {
            this.apiGridConfigurationService.saveAllChanges();
        }

        public selectApiGrid(apiGrid: Wars.Domain.Model.ApiGridConfiguration) {
            this.currentApiGrid = apiGrid;
            this.setFilteredApiActions();
        }


        public getName(schemaPropertyUniqueId: string): string {
            let property = Enumerable.from(this.selectedApiAction.outputObjectSchema.properties).single(p => p.uniqueIdentifier == schemaPropertyUniqueId);

            return property.name;
        }

        public removeColumn(column: Wars.Domain.Model.ApiGridColumnConfiguration) {
            column.entityAspect.setDeleted();
            this.apiGridConfigurationService.saveAllChanges();
        }

        public addSystemAction(action: Wars.Domain.Model.SystemAction) {
            let column = this.getNewColumn();

            column.name = action.name;
            column.displayName = action.name;
            column.type = Wars.Domain.Model.Codes.Enums.ApiGridColumnType.ProcessAction;

            column.systemAction = action;
            column.position = this.currentApiGrid.columns.length;

            this.currentApiGrid.columns.push(column);
            this.save();
        }

        public addTextProcessLink() {
            let column = this.getNewColumn();

            column.name = 'Navigate to Process';
            column.displayName = 'View';
            column.type = Wars.Domain.Model.Codes.Enums.ApiGridColumnType.TextProcessLink;
            column.isProcessLink = true;

            column.position = this.currentApiGrid.columns.length;

            this.currentApiGrid.columns.push(column);
            this.save();
        }

        public selectApiAction() {
            this.setSelectedApiAction();

            this.setColumns(this.selectedApiAction.outputObjectSchema);

            this.save();
        }

        private removeColumns() {
            Enumerable.from(this.currentApiGrid.columns).toArray().forEach(c => {
                c.entityAspect.setDeleted();
            });
        }
        private getNewColumn():Wars.Domain.Model.ApiGridColumnConfiguration {
            let column = this.apiGridConfigurationService.createApiGridColumn();

            column.hide = false;
            column.isProcessLink = false;
            column.isFilterable = false;
            column.isSortable = false;
            column.noWrap = false;

            return column;
        }

        private setColumns(objectSchema:Wars.Domain.Model.ObjectSchema) {
            this.removeColumns();
            var index = 0;

            for (let i = 0; i < objectSchema.properties.length; i++) {

                if (objectSchema.properties[i].typeSchema) {
                    for (var x = 0; x < objectSchema.properties[i].typeSchema.properties.length; x++) {
                        this.addColumn(objectSchema.properties[i].typeSchema.properties[x], index);
                        index++;
                    }
                } else {
                    this.addColumn(objectSchema.properties[i], index);
                    index++;
                }

            } 
        }

        private addColumn(property:Wars.Domain.Model.SchemaProperty,index:number) {
            let column = this.getNewColumn();

            column.schemaPropertyUniqueId = property.uniqueIdentifier;
            column.name = property.name;
            column.displayName = property.name;

            if (property.name.startsWith('_')) {
                column.hide = true;
            }

            if (property.propertyType == Wars.Domain.Model.Codes.Enums.VariableType.TimeTracker) {
                column.type = Wars.Domain.Model.Codes.Enums.ApiGridColumnType.Clock;
            } else {
                column.type = Wars.Domain.Model.Codes.Enums.ApiGridColumnType.Data;
            }

            column.position = index + 1;

            this.currentApiGrid.columns.push(column);
        }

        private setSelectedApiAction() {
            this.selectedApiAction = Enumerable.from(this.filteredApiActions).singleOrDefault(a => a.uniqueId == this.currentApiGrid.apiUniqueId);
        }

        public orderDown(column: Wars.Domain.Model.ApiGridColumnConfiguration) {
            const newPosition = column.position + 1;

            var oldColumn = Enumerable.from(this.currentApiGrid.columns).singleOrDefault(c => c.position == newPosition);

            if (oldColumn) {
                oldColumn.position--;
                column.position++;
            }
        }

        public orderUp(column: Wars.Domain.Model.ApiGridColumnConfiguration) {
            const newPosition = column.position - 1;

            var oldColumn = Enumerable.from(this.currentApiGrid.columns).singleOrDefault(c => c.position == newPosition);

            if (oldColumn) {
                oldColumn.position++;
                column.position--;
            }
        }

        public addApiGridConfiguration() {
            this.currentApiGrid = this.apiGridConfigurationService.createApiGridConfiguration();
            this.currentApiGrid.processConfiguration_id = this.processConfigurationId;
            this.currentApiGrid.isSelectable = false;
            this.currentApiGrid.allowColumnsToBeHidden = true;
            this.currentApiGrid.allowSaveState = false;
            this.currentApiGrid.usePaging = false;


            this.save();
        }

        private setFilteredApiActions() {
            this.filteredApiActions = Enumerable.from(this.apiActions).where(a => a.processConfiguration.processType_id == this.currentApiGrid.processType_id)
                .distinct(a => a.uniqueId).toArray();

            this.setSelectedApiAction();
        }

        public processTypeChanged() {
            this.setFilteredApiActions();
            this.currentApiGrid.apiUniqueId = null;

            this.save();
        }

        public objectQueryChanged() {
            this.currentApiGrid.apiUniqueId = null;
            this.currentApiGrid.processType_id = null;

            if (this.currentApiGrid.objectQuery) {
                this.setColumns(this.currentApiGrid.objectQuery.myProjectionObjectSchema);
            } else {
                this.currentApiGrid.objectQuery_id = null;
                this.removeColumns();;
            }

            this.save();
        }

        public deleteApiGridConfiguration() {
            this.deleteService.deleteWithModalConfirmationIfNecessary("ApiGridConfiguration", this.currentApiGrid.id);
            this.apiGridConfigurations.remove(this.currentApiGrid);
            this.currentApiGrid = null;
        }

        public systemActions: Wars.Domain.Model.SystemAction[];
    }
}